import { AnalyticsBrowser } from '@segment/analytics-next';
import { SEGMENT_WRITE_KEY } from '@constants/keys';
import { SegmentEvents, normalizeMethod } from './segmentEvents';
import { strogging } from '@shd/jslib/infra';
import { theGlobalAppHost } from './appHost';

const analyticsBrowser = AnalyticsBrowser.load({
  writeKey: SEGMENT_WRITE_KEY,
});

interface EventProps {
  method?: string;
  type?: string;
  step?: string;
  sport?: string | null;
  teamName?: string;
  teamLevel?: string;
  under13?: boolean;
  source?: string;
  hasRoster?: boolean;
  teamId?: string;
  hasDestination?: boolean;
  gameId?: string;
  date?: string;
  opponent_name?: string;
  sanctioning_partner?: string | number;
  current_status?: string;
  userType?: string;
  role?: string;
  scoring_link?: boolean;
  action_taken?: string;
  context?: string;
  playerId?: string;
  initialPreset?: string;
  initialScoreboardPosition?: string;
  initialPlayerCardFlipped?: boolean;
}

function identifyUser(
  userId: string,
  name?: string,
  email?: string,
  phoneNumber?: string
) {
  const appHost = theGlobalAppHost();
  if (appHost.isHosted) {
    try {
      appHost.service.notifications.identifySegmentUser(
        userId,
        name,
        email,
        phoneNumber
      );
    } catch (e: unknown) {
      strogging.log(
        'segment event: identifySegmentUser not available',
        (e as { message: string }).message
      );
    }
  } else {
    strogging.log('segment event: identifyUser', {
      userId,
      name,
      email,
      phoneNumber,
    });
    analyticsBrowser.identify(userId, {
      name,
      email,
      phoneNumber,
    });
  }
}

function track(eventName: SegmentEvents | string, props: EventProps) {
  let currProps = props;
  if (props.method) {
    currProps = {
      ...currProps,
      method: normalizeMethod(props.method as string),
    };
  }
  const appHost = theGlobalAppHost();
  if (appHost.isHosted) {
    try {
      appHost.service.notifications.trackSegmentEvent(eventName, {
        ...currProps,
      });
    } catch (e: unknown) {
      strogging.log(
        'segment event: trackSegmentEvent not available',
        (e as { message: string }).message
      );
    }
  } else {
    strogging.log('segment event: track', { eventName, currProps });
    analyticsBrowser.track(eventName, { ...currProps });
  }
}

export default {
  identifyUser,
  track,
};
export { SegmentEvents, type EventProps };
